import {Component, EventEmitter, Input, Output } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import {AdfiService} from '@services/adfi-service';
import {AdfiGraphqlService} from '@services/adfi-graphql.service';
import {LoadingService} from '@services/loading.service';
import {Entities, Permission, Property, PeriodState} from '@Interfaces/index';
import {AdfiGrowlService} from '@services/adfi-growl.service';

interface FoodNode {
  children?: FoodNode[];
  expandable?: boolean;
  level?: number;
}
@Component({
  selector: 'app-tree-presupuesto',
  templateUrl: './tree-presupuesto.component.html',
  styleUrls: ['./tree-presupuesto.component.css'],
})
export class TreePresupuestoComponent {

  @Input() externalPermission = true;
  @Input() customFilter: string;
  @Input() decimals = 0;
  /**
   * Creates an instance of prmini presupuesto component.
   */
  constructor(public service: AdfiService,
              public graphqlService: AdfiGraphqlService,
              public sLoading: LoadingService,
              public alert: AdfiGrowlService) {
    this.block = this.service.validPermission('BlockingPlatform', 'lock', PeriodState.NO_STATUS);  
    this.maxHeight = window.innerHeight - 240;
    this.valorTotal = '';
    this.edit = !this.service.validPermission(Entities.INITIAL_BUDGET, Permission.APPROVE);
  }

  loading = false;
  data = [];
  source: number;
  helps = [];
  /**
   * Input  of tree presupuesto component
   */
  @Input() tipoPresupuesto: 'E' | 'I';

  @Input() sumValue = true;

  @Input() entity = 'prMiniPresupuestos';

  @Input() strQuery = 'nombre prminNFuente { id prfinVNombre } minipresu descompuesto agrupador valor estadoPresupuesto';

  @Input() idGroup = '_id';

  @Input() customSave: (node: any, tree: TreePresupuestoComponent, item: any, field: Property) => void;

  @Input() item: any;

  @Input() field: Property;

  @Input() typeTransfer: 'CC' | 'CR';

  @Input() value: number;

  @Output() changeItem = new EventEmitter<any>();

  /**
   * Max height of prmini presupuesto component
   */
  public readonly maxHeight: number;

  /**
   * Index selected of tab
   */
  public tabIndex: number;

  /**
   * Valor total of tree presupuesto component
   */
  public valorTotal: string;

  public edit: boolean;
    
  public block : boolean;

  // tslint:disable-next-line: member-ordering
  treeControl = new FlatTreeControl<FoodNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  transformer(node, level: number) {
    return {
      id: node.id,
      expandable: !!node.children && node.children.length > 0,
      level,
      minipresu: node.minipresu,
      nombre: node.nombre,
      valor: node.valor,
      valorIn: node.valor,
      descompuesto: node.descompuesto,
      estadoPresupuesto: node.estadoPresupuesto,
      prminNFuente: node.prminNFuente,
      vigencia: node.vigencia,
      tipoPresu: node.tipoPresu,
      agrupador: node.agrupador,
      modificationId: node.modificationId,
      detailModificationId: node.detailModificationId,
      valueAvailable: node.valueAvailable,
      descriptionHelp: node.descriptionHelp
    };
  }

  public async update() {
    this.data = [];
    this.loadTree();
    const next = async (response) => {
      this.data = response;
      this.data = this.data.map(element => ({
        ...element,
        descriptionHelp: this.findHelpDescription(element.minipresu)
      }));
      const item3 = this.data.find(item => item.minipresu === '1.003.1.02.06.001.01.03.02.01' && item.valueAvailable != 0)
      if(item3 && item3.modificationId){
         this.data.push({
           "nombre": "Matrícula Y Jornada Única",
           "descompuesto": "S",
           "agrupador": 6148,
           "detailModificationId":item3.detailModificationId,
           "modificationId":item3.modificationId,
           "minipresu":item3.minipresu,
           valueAvailable: null,
           "valor": null
         },{
           "nombre": "Total Formación Integral",
           "descompuesto": "S",
           "agrupador": 6148,
           "detailModificationId":item3.detailModificationId,
           "modificationId":item3.modificationId,
           "minipresu":item3.minipresu,
           valueAvailable: null,
           "valor": null
         },{
           "nombre": "Dotación Primera Infancia",
           "descompuesto": "S",
           "agrupador": 6148,
           "detailModificationId":item3.detailModificationId,
           "modificationId":item3.modificationId,
           "minipresu":item3.minipresu,
           valueAvailable: null,
           "valor": null
         })

         const mapSource3: Record<string, string> = {
           "Matrícula Y Jornada Única": "NM",
           "Total Formación Integral": "IT",
           "Dotación Primera Infancia": "EC"
         };
          try {
            const result: any = await this.service.getActualValuesAdditionControl(
              this.service.user.period,
              item3.modificationId
            ).toPromise();

            if (result?.response?.length) {
              if (result.response.length > 3) {
                this.sLoading.hide();
                this.alert.errorMessage("Error: consulte con soporte y proporcione el código:7880");
              } else {
                // Actualizar valores
                this.data = this.data.map(d => {                  
                  const typeIncome = mapSource3[d.nombre];
                  const originValue = result.response.find(o => o.nameType === typeIncome);
      
                  return {
                    ...d,
                    valor: originValue?.value ?? d.valor,
                    valueAvailable: originValue?.available ?? d.valueAvailable,
                    descompuesto: originValue?.descompuesto ?? d.descompuesto
                  };
                });
                 const item = this.data.find(d => d.minipresu === '1.003.1.02.06.001.01.03.02.01' && d.nombre === 'Recurso CONPES - gratuidad');
                 if (item) {
                   item.children = null;
                 }
              }
            }
          } catch (error) {
            this.sLoading.hide();
            this.alert.errorMessage(error);
          }
                
      }
      if (this.item && this.item._id === 32528 && this.item.tramtrDocStatus === 'I'){
        if (this.typeTransfer === 'CC') {
          const ids = ["TRCCV6111", "TRCCV6112", "TRCCV5808", "TRCCV5814","TRCCV5818","TRCCV6235","TRCC32528V6235"];
          this.data = this.data.filter(d => ids.includes(d._id));
          
          const item = this.data.find(d => d._id === "TRCCV6235");
          if (item) item.descompuesto = 'V';
        }else if (this.typeTransfer === 'CR') {
          this.data = this.data.filter(d => d.minipresu?.toString().startsWith("2.005"));
          this.data = this.data.filter(d => d.descompuesto !== "V" && d._id !== "TRCCV6235");
          const minipresus = new Set(["2.005.1.2.01.01.003.03.01.01", "2.005.1.2.01.01.003.03.02.01", "2.005.1.2.01.01.004.01.01.01","2.005.1.2.01.01.004.01.01.02", "2.005.1.2.01.01.004.01.01.03", "2.005.1.2.01.01.004.01.01.04","2.005.1.2.02.01.001.01", "2.005.1.2.02.01.001.02", "2.005.1.2.02.01.001.03",
            "2.005.1.2.02.01.003.01", "2.005.1.2.02.01.004.01", "2.005.1.2.02.02.007.001", "2.005.1.2.02.02.007.002", "2.005.1.2.02.02.007.003", "2.005.1.2.02.02.008.01", "2.005.1.2.02.02.008.02", "2.005.1.2.02.02.008.03", "2.005.1.2.02.02.008.04", "2.005.1.2.02.02.008.05", "2.005.1.2.02.02.008.06", "2.005.1.2.02.02.008.07", "2.005.1.2.02.02.008.08", "2.005.1.2.02.02.008.09", "2.005.1.2.02.02.008.10", "2.005.1.2.02.02.008.11",
            "2.005.1.2.02.02.009.01", "2.005.3.2.01.01.003.02.08.01.01", "2.005.3.2.01.01.003.02.08.01.02", "2.005.3.2.01.01.003.02.08.01.03", "2.005.3.2.01.01.003.02.08.01.04", "2.005.3.2.01.01.003.02.08.01.05", "2.005.3.2.01.01.003.02.08.01.06", "2.005.3.2.01.01.003.02.08.01.07", "2.005.3.2.01.01.003.02.08.01.08", "2.005.3.2.01.01.003.02.08.01.09", "2.005.3.2.01.01.003.03.02.01", "2.005.3.2.01.01.004.01.01.01", "2.005.3.2.01.01.004.01.01.04", "2.005.3.2.01.01.004.01.01.05", "2.005.3.2.01.01.004.01.01.06", "2.005.3.2.01.01.004.01.02.01", "2.005.3.2.01.01.004.01.03.01", "2.005.3.2.01.01.005.01.01.08.01.01", "2.005.3.2.01.01.005.01.01.08.01.02", "2.005.3.2.01.01.005.01.01.08.01.03", "2.005.3.2.01.01.005.01.01.08.01.04", "2.005.3.2.01.01.005.01.01.08.01.05", "2.005.3.2.01.01.005.01.01.08.01.06", "2.005.3.2.01.01.005.01.01.08.01.07", "2.005.3.2.01.01.005.01.01.08.01.08", "2.005.3.2.01.01.005.01.01.08.01.09",
            "2.005.3.2.01.01.005.01.01.08.01.10", "2.005.3.2.01.01.005.01.01.08.01.11", "2.005.3.2.01.01.005.01.02.06.01", "2.005.3.2.01.01.005.02.03.01.01.01", "2.005.3.2.01.01.005.02.05.01", "2.005.3.2.02.01.000.01", "2.005.3.2.02.01.003.01", "2.005.3.2.02.01.003.02", "2.005.3.2.02.02.006.01", "2.005.3.2.02.02.008.01", "2.005.3.2.02.02.009.01", "2.005.3.2.02.02.009.02", "2.005.3.2.02.02.009.03", "2.005.3.2.02.02.009.04", "2.005.3.2.02.02.009.05"
          ]);

          this.data.forEach(d => {
            if (minipresus.has(d.minipresu)) {
              d.descompuesto = 'V';
            }
          });
        }
      }  
      this.loading = false;
      this.sLoading.hide();
      if (this.data.length > 0) { this.loadTree(); }
    };
    const error = (e) => {
      this.loading = false;
      this.sLoading.hide();
      this.alert.errorMessage(e);
    };
    this.loading = true;
    this.sLoading.show();
    const filters = this.customFilter ? this.customFilter : `tipoPresu: "${this.tipoPresupuesto}" ${this.source ? `, prminNFuente: "${this.source}"` : ''}, vigencia: ${this.value}`;
    const max = await this.graphqlService.countEntity(this.entity, filters);
    this.graphqlService.getEntity(this.entity,
        this.strQuery,
        max,
        filters,
        {next, error}
    );
  }

  selectPrFuente(id: number) {
    this.source = id;
    this.getHelps();
    this.update();
  }

  private loadTree() {
    const source: FoodNode[] = [];

    for (const item of this.data) {
      const agrupador = this.findParent(item.agrupador, source);
      if (!agrupador) { source.push(item); } else {
        if (!agrupador.children) { agrupador.children = [item]; } else { agrupador.children.push(item); }
      }
    }
    this.tabIndex = 0;
    // minipresu: 'I' === this.tipoPresupuesto ? 'Ingresos' : 'Gastos',
    this.dataSource.data = source;
    this.treeControl.expandAll();
    this.sumValor();
  }

  findParent(id: string, source: any[]): FoodNode {
    let agrupador = null;

    for (const s of source) {
      if (s.children) { agrupador = this.findParent(id, s.children); }
      if (agrupador) { return agrupador; } else if (s[this.idGroup] + '' === id + '') { return s; }
    }

    return agrupador;
  }

  save(prMini) {
    if (this.customSave){
      this.customSave(prMini, this, this.item, this.field);
    } else {
      this.sLoading.show();
      const next = () => {
        this.sLoading.hide();
        this.alert.success('Correcto', 'Rubro correctamente guardado');
        this.update();
        this.changeItem.emit(true);
      };
      const error = (e) => {
        this.sLoading.hide();
        this.alert.errorMessage(e);
      };
      this.graphqlService.updateEntity('PrMiniPresupuesto', {
        id: prMini.id,
        valor: prMini.valor,
      }, undefined, {next, error});
    }
  }

  sumValor() {
    let valor = 0;
    for (const data of this.data) {
      if (data.descompuesto === 'S' || data.minipresu.startsWith('2.005')) { 
        continue;
      }
      valor += data.valor;
    }
    // to fixed sum egre automatic adition balance resourse
    if(valor === 0){
      for (const data of this.data) {
          if(valor === 0 && data.valor !== 0 && data.minipresu === '2.005'){
            valor += data.valor;
          }
      }
    }
    this.valorTotal = valor.toFixed(2);
  }

  getHelps() {
    this.service.getHelps(this.value).subscribe(
        (data) => {
            this.helps= data.response;
        },
        (error) => {
            console.warn("Problema al cargar los datos");
        }
    );
}

findHelpDescription(minipresu: string) {
    const matchedItem = this.helps.find(item => item.V_MINIPRESU === minipresu);
    return matchedItem ? matchedItem.DESCRIPTION : '';
}

  hasChild = (_: number, node: FoodNode) => node.expandable;
}
